import { GeneralVolumeUnits, GeneralWeightUnits } from '@/constants/measurementUnits';
import { useUnitsStore } from '@/store/modules/useUnitsStore';

export const getDefaultImportVolumeUnit = (): GeneralVolumeUnits => {
  return useUnitsStore().importVolumeUnit;
};

export const getDefaultImportWeightUnit = (): GeneralWeightUnits => {
  return useUnitsStore().importWeightUnit;
};

export const getDefaultExportVolumeUnit = (): GeneralVolumeUnits => {
  return useUnitsStore().exportVolumeUnit;
};

export const getDefaultExportWeightUnit = (): GeneralWeightUnits => {
  return useUnitsStore().exportWeightUnit;
};

export const getDefaultExportTotalVolumeUnit = (): GeneralVolumeUnits => {
  return useUnitsStore().exportTotalVolumeUnit;
};
